import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { createRequestOption } from 'src/app/auth/request/request-util';
import { environment } from 'src/environments/environment';

export type EntityArrayResponseType = HttpResponse<any[]>;
export type EntityResponseType = HttpResponse<any>;

@Injectable()
export class DepartmentListService {
    protected resourceFliterUrl = environment.SERVER_API_URL+('api/departmentList');
    protected resourceSaveUrl = environment.SERVER_API_URL+('api/saveDepartment');
    protected resourseGetUrl = environment.SERVER_API_URL+('api/')
    constructor(protected http: HttpClient) {}
    filter(): Observable<EntityArrayResponseType> {
      
        return this.http
        .get<any[]>(this.resourceFliterUrl,{ observe: 'response' })
    }
    save(departmentList?:any): Observable<EntityResponseType> {
        return this.http
        .post<any>(this.resourceSaveUrl,departmentList, {observe: 'response' })
    }
}